import * as moment from "moment";

export const required = function (value) {
    return value && value.length;
};

export const requiredSelect = function (value) {
    return value && value != "-1";
};

export const requiredDate = function (value) {
    return value && !value.toString().includes("/-1") && moment(value).isValid();
};

export const requiredBool = function (value) {
    return value;
};

export const validEmail = function (value) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return !value || value.length == 0 || re.test(value);
};

export const maxLength = function (maxLength, value) {
    return !value || (value && value.length < maxLength);
};

export const numeric = function (value) {
    return !isNaN(value);
};

export const matchingPassword = function (values) {
    if(!values.passwordConfirm || values.passwordConfirm.length === 0)
        return true;

    return values.passwordConfirm === values.password
}

export const formLevelIsWeakPassword = function(values) {
    return !values || !values.password || isWeakPassword(values.password)
};

export const isWeakPassword = function(value) {
    var re = /^(?=.*[A-Z])(?=.*[a-z]).{8,}/;  
    return !value || value.length == 0 || re.test(value);
};